<template>
  <section class="faq">
    <div class="v2-container-small">
      <img
        v-if="stickerUrl"
        id="faqSticker"
        :src="stickerUrl"
        alt="sticker"
        class="faq__sticker"
        loading="lazy"
      >

      <h2 class="faq__title">
        Собрали для вас ответы на частые и&nbsp;волнующие вопросы
      </h2>

      <div class="accordion">
        <div
          v-for="(item, index) of items"
          :key="index"
          class="accordion__item"
        >
          <h6
            class="accordion__item--head"
            @click="toggleAccordion(index)"
          >
            <img
              v-if="!openedItems.includes(index)"
              src="/v2/common/faq/plus.svg"
              alt="plus"
              loading="lazy"
            >
            <img
              v-else
              src="/v2/common/faq/minus.svg"
              alt="minus"
              loading="lazy"
            >
            <span v-html="item.title" />
          </h6>

          <div
            :class="[
              'accordion__item--body',
              `accordion__item--body--${index}`,
              { 'active' : openedItems.includes(index) },
            ]"
            :style="{ height: !openedItems.includes(index) ? 0 : getHeight(index) }"
            v-html="item.body"
          />
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import faqData from './FaqData';

export default {
  name: 'FaqAccordionNew',

  props: {
    page: {
      type: String,
      required: true,
    },
    stickerUrl: {
      type: String,
      default: '/v2/school/faq/star.webp',
    },
  },
  data: () => ({
    openedItems: [],
  }),
  computed: {
    items() {
      return faqData[this.page] || [];
    },
  },

  methods: {
    getHeight(index) {
      if (process.browser) {
        // ждем отрисовки DOM
        const accBody = document.querySelector(`.accordion__item--body--${index}`)?.scrollHeight || 0;
        return `${accBody + 10}px`;
      }

      return 0;
    },
    toggleAccordion(number) {
      if (this.openedItems.includes(number)) {
        this.openedItems = this.openedItems.filter((i) => i !== number);
      } else {
        this.openedItems.push(number);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.faq {
  &__sticker {
    position: absolute;
  }

  &__title {
    max-width: 820px;

    font-size: 45px;
    font-weight: 700;
    line-height: 110%;
    letter-spacing: -0.03em;
    text-transform: uppercase;
    color: $black-color;
    position: relative;
    z-index: 1;

    @include media-down(tablet) {
      padding-left: 8px;
      padding-right: 8px;
      font-size: 26px;
      letter-spacing: -0.02em;
    }
  }

  .accordion {
    margin-top: 60px;
    display: flex;
    flex-direction: column;
    gap: 10px;
    position: relative;
    z-index: 1;

    @include media-down(tablet) {
      margin-top: 32px;
      gap: 8px;
    }

    &__item {
      position: relative;
      padding: 20px;

      border-radius: 20px;
      background-color: $white-color;
      box-shadow: 4px 4px 20px 0 rgba($ege-blue-darkest, .05);

      @include media-down(tablet) {
        padding: 16px;
      }

      &--head {
        display: flex;
        align-items: center;
        gap: 10px;
        cursor: pointer;

        @include media-down(tablet) {
          gap: 8px;
          align-items: flex-start;
        }

        img {
          @include media-down(tablet) {
            width: 16px;
            height: 22px;
            object-fit: contain;
            object-position: center;
          }
        }

        span {
          max-width: 730px;
          font-size: 24px;
          font-weight: 500;
          line-height: 130%;
          color: $black-color;

          @include media-down(tablet) {
            font-size: 18px;
            line-height: 120%;
          }
        }
      }

      &--body {
        max-width: 875px;
        padding-left: 28px;
        padding-top: 0;
        opacity: 0;
        pointer-events: none;
        transition: all .4s;

        @include media-down(tablet) {
          padding-left: 24px;
        }

        ::v-deep {
          font-size: 18px;
          font-weight: 500;
          line-height: 128%;
          letter-spacing: -0.01em;
          color: $grey2;

          @include media-down(tablet) {
            font-size: 16px;
            line-height: 130%;
          }
        }
      }
      &--body.active {
        padding-top: 10px;
        opacity: 1;
        pointer-events: auto;

        @include media-down(tablet) {
          padding-top: 4px;
        }
      }
    }
  }
}
</style>
